import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

import { Centered500 } from '../arkulpa-fec/components/Container';
import { HeadlineH1 } from '../arkulpa-fec/components/Text';
import { convertErrors } from '../arkulpa-fec/utils/errorHelper';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';
import ErrorMessage from '../arkulpa-fec/components/ErrorMessage';

const StyledActionButtonRow = styled(ActionButtonRow)`
  margin: 20px -15px 0px;
  padding: 10px 20px;
`;

export default class extends Component {
  state = {password: '', repeatPassword: '', changed: false};

  render() {
    let {password, repeatPassword, changed} = this.state;
    return (
      <Centered500>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        <HeadlineH1>Passwort ändern</HeadlineH1>
        {changed
          ? <div>
              Dein Passwort wurde erfolgreich geändert.
              <br />
              Du kannst dich nun wieder bei EvenTZ anmelden.
              <StyledActionButtonRow>
                <div />
                <FlatButton primary onClick={() => this.props.history.replace('/login')} label="Zum Login" />
              </StyledActionButtonRow>
            </div>
          : <div>
              Hier kannst du dein Passwort für EvenTZ ändern.<br />
              Anschließend kannst du dich wieder anmelden.
              <TextField
                type="password"
                fullWidth={true}
                floatingLabelText="Passwort"
                value={password}
                autoFocus
                onChange={({target: {value}}) => this.setState({password: value})}
              />
              <TextField
                type="password"
                fullWidth={true}
                floatingLabelText="Passwort wiederholen"
                value={repeatPassword}
                onChange={({target: {value}}) => this.setState({repeatPassword: value})}
              />
              <StyledActionButtonRow>
                <div />
                <FlatButton
                  primary
                  onClick={() =>
                    this.props.changePassword(password).then(() => this.setState({changed: true})).catch(rawErrors => {
                      let errors = convertErrors(rawErrors);
                      this.setState({errors});
                      console.log('there was an error sending the change password mutation', errors);
                    })}
                  label="Passwort ändern"
                  disabled={!(password.length || repeatPassword.length) || password !== repeatPassword}
                />
              </StyledActionButtonRow>
            </div>}
      </Centered500>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js